// extracted by mini-css-extract-plugin
export var addButton = "_di-0";
export var border = "_di-8";
export var check = "_di-h";
export var danger = "_di-6";
export var dropdownContainer = "_di-1";
export var editModalBody = "_di-j";
export var footerContainer = "_di-i";
export var fullWidth = "_di-a";
export var hide = "_di-9";
export var icon = "_di-3";
export var input = "_di-7";
export var inputFlex = "_di-b";
export var inputWrapper = "_di-c";
export var manualFocus = "_di-5";
export var optionButton = "_di-4";
export var pillWrapper = "_di-e";
export var pointer = "_di-2";
export var showOverflow = "_di-f";
export var tagsFlex = "_di-d";
export var xButton = "_di-g";